import React, { Component } from 'react';

import imagen  from '../../../assets/img/header-banner-1.png';

class SubItem1 extends Component {
    state = {  }
    render() { 
        return (
            <div className="header" id = "item1">
                <div className="header-banner2" style={{backgroundImage: `url(${imagen})`, paddingLeft: "10%", paddingRight: "10%", paddingTop: 40, paddingBottom: 40}}>
                    <div style={{color:"a80012", fontSize: 30}} className="fuente-monserrat">A quiénes va dirigida</div>
                    <div align="justify" style={{color:"fff", fontSize: 16}} className="custom-mt-10 fuente-monserrat">
                        La carrera Publicidad y Mercadeo va dirigida a bachilleres creativos, innovadores, proactivos, dispuestos a asumir retos y poner a prueba su ingenio en la comercialización de productos, demostrando sus habilidades comunicativas e interacción personal con el entorno, habilidades tecnológicas, desarrollo creativo en todas sus expresiones, capacidad de observación, análisis e investigación, con  liderazgo y destrezas para trabajar en equipo.
                    </div>
                </div>
            </div>
        );
    }
}
 
export default SubItem1;


// WEBPACK FOOTER //
// ./src/site/Componentes/PublicidadMercadeo/SubItem1.jsx